import React, {useEffect, useState} from "react";
import {BasicProps} from "../Main";
import {Grid} from "@mui/material";
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiButton} from "../Components/SamaggiButton";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {handleError} from "../support";

interface GalleryImage {
    key: string;
    url: string;
}

export const Gallery: React.FC<BasicProps> = (props) => {
    const [pageLoaded, setPageLoaded] = useState(false);
    const [images, setImages] = useState<GalleryImage[]>([]);

    const navigate = useNavigate();

    useEffect(() => {
        props.setShowCover(true);
        load(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function load() {
        props.setShowCover(true);

        const token = localStorage.getItem("token");

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/gallery/list", {
            "token": token
        }).then((res) => {
            setImages(res.data.data.images || []);
            setPageLoaded(true);
            props.setShowCover(false);
        }).catch((error) => {
            props.setShowCover(false);
            handleError(error, true);
        });
    }

    return (
        <>
            <Grid container direction={"column"} spacing={3}>
                <Grid item container direction={"column"} spacing={2}>
                    <Grid item>
                        <SamaggiTypography center xlarge bold>Staff Gallery</SamaggiTypography>
                    </Grid>
                    <Grid item>
                        <SamaggiTypography center small>
                            Browse the latest images from staff events and activities.
                        </SamaggiTypography>
                    </Grid>
                </Grid>
                {pageLoaded && (
                    <Grid item container direction={"row"} spacing={2}>
                        {images.map((image) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={image.key}>
                                <div style={{width: "100%", paddingTop: "100%", position: "relative", borderRadius: "8px", overflow: "hidden", border: `1px solid ${Colours.gray}`}}>
                                    <img
                                        src={image.url}
                                        alt={image.key}
                                        style={{position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover"}}
                                    />
                                </div>
                            </Grid>
                        ))}
                        {images.length === 0 && (
                            <Grid item xs={12}>
                                <SamaggiTypography center small>
                                    No images are available in the gallery yet.
                                </SamaggiTypography>
                            </Grid>
                        )}
                    </Grid>
                )}
                <Grid item>
                    <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray}
                                   onClick={() => {navigate("/")}}>
                        Back to Staff Portal
                    </SamaggiButton>
                </Grid>
            </Grid>

        </>
    );
}
